import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { SiteContext } from '@homeplay/app';
import classes from './Jackpot.module.scss';

const JackpotBanner = ({image}) => {
  const { siteName } = useContext(SiteContext);

  if (!image) return null;

  return (
    <div className={classes.JackpotBannerWrap}>
      <Link to={`/${siteName ? siteName + '/' : ''}jackpot`}>
        <img src={image} alt="Jackpot Banner" />
      </Link>
    </div>
  );
};

export default React.memo(JackpotBanner);
